import { render, staticRenderFns } from "./HookInfoEdit.vue?vue&type=template&id=56fe9d3e&scoped=true&"
import script from "./HookInfoEdit.vue?vue&type=script&lang=js&"
export * from "./HookInfoEdit.vue?vue&type=script&lang=js&"
import style0 from "./HookInfoEdit.vue?vue&type=style&index=0&id=56fe9d3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fe9d3e",
  null
  
)

export default component.exports